enum SubstitutionOption {
    None = 0,
    DateOnly = 1,
    TimeOnly = 2
}

export default SubstitutionOption;